import mantenimiento from "../assets/images/mantenimiento.jpg";

const Mantenimiento = () => {
  return (
    <div className="container">
      <div className="d-flex justify-content-center">
        <img
          src={mantenimiento}
          className="img-fluid img-man "
          alt="Mantenimiento"
        />
      </div>
    </div>
  );
};

export default Mantenimiento;